import script from "./monthly-collections-report.vue?vue&type=script&setup=true&lang=js"
export * from "./monthly-collections-report.vue?vue&type=script&setup=true&lang=js"

import "./monthly-collections-report.vue?vue&type=style&index=0&id=2af7277c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af7277c"]])

export default __exports__